import React, { useState } from "react";
import "../styles/AddMatchPopup.css";
import { add_ball } from "../api/serverWrapper";
import { FIXED_BASE_URL } from "../api/app_urls";

export default function AddBallPopup({
  drsTypes,
  matchData,
  onClose,
  loadData,
  cricketAsscotions,
}) {
  const [ballData, setBallData] = useState({
    Id: "-1",
    MatchId: "",
    DRSTypeId: "",
    Description: "",
    BallUrl: "",
    DRSVideoUrl: "",
    DeploymentSystemId: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [generatedUrl, setGeneratedUrl] = useState("");

  // ✅ Helper to generate API URL
  const generateApiUrl = (ballUrl, matchId, overrideDeploymentSystemId) => {
    const regex = /^b_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)$/;
    const match = ballUrl.match(regex);
    if (!match) return "";

    const [, mId, inningNum, overNum, ballNum, extraIndex] = match;

    // Find match association
    const selectedMatchAssoc = matchData.find(
      (assoc) => assoc.MatchId === Number(matchId)
    );

    let deploymentIdToUse = Number(overrideDeploymentSystemId);
    let selectedAssociation = null;

    // ✅ If override is not passed, get from match
    if (!deploymentIdToUse && selectedMatchAssoc) {
      deploymentIdToUse = selectedMatchAssoc.DeploymentSystemId;
    }

    selectedAssociation = cricketAsscotions.find(
      (assoc) => assoc.DeploymentSystemId === deploymentIdToUse
    );
    console.log("Match ID:", matchId);
    console.log("deploymentIdToUse:", deploymentIdToUse);
    
    
    console.log("Selected Association:", selectedAssociation);
    

    if (!selectedAssociation) return "";

    return `b_${mId}_${inningNum}_${overNum}_${ballNum}_${extraIndex}_${selectedAssociation.DeploymentSystemShortName}`;
  };

  // ✅ When any input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...ballData, [name]: value };
    setError("");

    // 🏏 When Match changes — auto-select its Cricket Association
    if (name === "MatchId") {
      const selectedMatch = matchData.find(
        (match) => match.MatchId === Number(value)
      );

      if (selectedMatch) {
        updatedData.DeploymentSystemId = selectedMatch.DeploymentSystemId || "";
      }
    }

    // 🏏 When Cricket Association changes manually — regenerate URL
    if (name === "DeploymentSystemId" && ballData.BallUrl && ballData.MatchId) {
      const apiUrl = generateApiUrl(
        ballData.BallUrl,
        ballData.MatchId,
        value // override with user-selected DeploymentSystemId
      );
      setGeneratedUrl(apiUrl);
    }

    // 🏏 When Ball URL changes — regenerate URL if MatchId exists
    if (name === "BallUrl" && ballData.MatchId) {
      const apiUrl = generateApiUrl(
        value,
        ballData.MatchId,
        updatedData.DeploymentSystemId
      );
      setGeneratedUrl(apiUrl);
    }

    setBallData(updatedData);
  };

  // ✅ Save Handler
  const handleSave = async () => {
    if (!ballData.MatchId || !ballData.DRSTypeId) {
      setError("Match and DRS Type are required.");
      return;
    }
    if (!ballData.Description) {
      setError("Match Ball Description is required.");
      return;
    }
    if (!ballData.BallUrl) {
      setError("Match BallUrl is required.");
      return;
    }

    const regex = /^b_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)$/;
    if (!ballData.BallUrl.match(regex)) {
      setError(
        "Invalid BallUrl format. Use: b_matchId_inningNumber_overNumber_ballNumber_extraIndex"
      );
      return;
    }

    // ✅ Construct API URL with the latest selected association
    const apiUrl = generateApiUrl(
      ballData.BallUrl,
      ballData.MatchId,
      ballData.DeploymentSystemId
    );

    const payload = { ...ballData };
    if (!ballData.DRSVideoUrl) delete payload.DRSVideoUrl;
    payload.BallUrl = apiUrl;

    try {
      setLoading(true);
      console.log("Payload to be sent:", payload);
      // return
      const response = await add_ball(payload);
      console.log("API Response:", response);
      onClose();
      loadData();
    } catch (err) {
      console.error("Error saving ball:", err);
      setError("Failed to save ball. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Options
  const renderDrsTypesOptions = () =>
    drsTypes.map((type) => (
      <option key={type.DRSTypeId} value={type.DRSTypeId}>
        {type.Title}
      </option>
    ));

  const renderMatchOptions = () =>
    matchData.map((item) => (
      <option key={item.MatchId} value={item.MatchId}>
        {item.Name}
      </option>
    ));

  const renderCricketAsscotionsOptions = () =>
    cricketAsscotions.map((assoc) => (
      <option key={assoc.DeploymentSystemId} value={assoc.DeploymentSystemId}>
        {assoc.DeploymentSystemName}
      </option>
    ));

  return (
    <div className="popup_overlay">
      <div className="popup_container">
        <div className="popup_header">
          <h2 className="popup_title">Add Ball</h2>
          <p className="popup_hint">Enter the ball details below</p>
        </div>

        <div className="popup_body">
          <div className="popup_input_container">
            <select
              name="MatchId"
              className="popup_input"
              value={ballData.MatchId}
              onChange={handleChange}
            >
              <option value="">Select Match</option>
              {renderMatchOptions()}
            </select>
          </div>

          <div className="popup_input_container">
            <select
              name="DeploymentSystemId"
              className="popup_input"
              value={ballData.DeploymentSystemId}
              onChange={handleChange}
            >
              <option value="">Select Cricket Association</option>
              {renderCricketAsscotionsOptions()}
            </select>
          </div>

          <div className="popup_input_container">
            <select
              name="DRSTypeId"
              className="popup_input"
              value={ballData.DRSTypeId}
              onChange={handleChange}
            >
              <option value="">Select DRS Type</option>
              {renderDrsTypesOptions()}
            </select>
          </div>

          <div className="popup_input_container">
            <input
              type="text"
              name="Description"
              placeholder="Enter Description for Ball"
              className="popup_input"
              value={ballData.Description}
              onChange={handleChange}
            />
          </div>

          <div className="popup_input_container">
            <input
              type="text"
              name="BallUrl"
              placeholder="Enter Ball Video URL"
              className="popup_input"
              value={ballData.BallUrl}
              onChange={handleChange}
            />
          </div>

          {error && <p className="popup_error">{error}</p>}

        </div>

        {/* <div className=""> {generatedUrl} </div> */}

        <div className="popup_footer">
          <button className="popup_btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="popup_btn popup_btn_primary"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
